import $ from 'jquery';

const instances = [];

function pad(num) {
	num = parseInt(num, 10);

	if (num < 10) {
		return `0${num}`;
	}

	return String(num);
}

function slideWidth(img) {
	img.forEach((img) => {
		let fig = img.closest('figure');
		if (fig) {
			let figcap = fig.querySelector('figcaption');
			if (figcap) {
				figcap.setAttribute('style', 'max-width:' + img.clientWidth + 'px')
			}
		}
	});
}

function mediaSlider(selector = '.media-slider__slides', settings = {}) {
	const config = Object.assign({
		adaptiveHeight: true,
	}, settings);

	const $nodes = $(selector);

	$nodes.find('[loading="lazy"]').attr('loading', 'eager');

	$nodes.each((index, node) => {
		const $node = $(node);
		const $slides = $node.find('.media-slider__slide');
		let img = document.querySelectorAll('.media-slider__slide img');

		let $pager;
		let $total;
		let $current;


		$node.on('init', () => {
			$pager = $('<div class="pager media-slider__pager"></div>').appendTo($node);

			$node.find('.slick-prev').appendTo($pager);

			$current = $(`<div class="pager__current">${pad(1)}</div>`).appendTo($pager);
			$total = $(`<div class="pager__total">${pad($slides.length)}</div>`).appendTo($pager);

			$node.find('.slick-next').appendTo($pager);
		});

		let slider = $node.slick(config);

		//console.log(config);

		$node.on('afterChange', (event, slick, currentSlide, nextSlide) => $current.text(pad(currentSlide + 1, 2)));

		// PL 3/7/22 remove calls to slideWidth to avoid vertical text bug on media slider
		
		// $(window).on('load', function () {
		// 	slideWidth(img);
		// })

		// $(window).on('resize', function () {
		// 	setTimeout(() => {
		// 		slideWidth(img);
		// 	}, 100);
		// })

		instances.push($node);
		window.gfi_sliders.push(slider);
	});

	return $nodes;
}

document.addEventListener('DOMContentLoaded', () => mediaSlider());

export default {
	mediaSlider,
	instances,
}


